import React, { useRef, useEffect } from "react";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";

function randomID(len = 5) {
  let result = "";
  var chars = "12345qwertyuiopasdfgh67890jklmnbvcxzMNBVCZXASDQWERTYHGFUIOLKJP",
    maxPos = chars.length;
  for (let i = 0; i < len; i++) {
    result += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return result;
}

function getUrlParams(url = window.location.href) {
  let urlStr = url.split("?")[1];
  return new URLSearchParams(urlStr);
}

function VideoMeeting() {
  const refContainer = useRef(null);
  const zpRef = useRef(null);
  const localStreamRef = useRef(null); // Define localStreamRef here to hold the media stream

  useEffect(() => {
    const roomID = getUrlParams().get("roomID") || randomID();
    const appID = 1458356387; // This should be obtained securely for production
    const serverSecret = "99d0c3468e390606b58b40e7c2139c14"; // This should NOT be hardcoded in production
    const userID = randomID();
    const userName = randomID();

    const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
      appID,
      serverSecret,
      roomID,
      userID,
      userName
    );

    if (refContainer.current) {
      zpRef.current = ZegoUIKitPrebuilt.create(kitToken);
      if (zpRef.current) {
        zpRef.current.joinRoom({
          container: refContainer.current,
          sharedLinks: [
            {
              name: "Personal link",
              url: `${window.location.protocol}//${window.location.host}${window.location.pathname}?roomID=${roomID}`,
            },
          ],
          scenario: { mode: ZegoUIKitPrebuilt.GroupCall },
        });
      } else {
        console.error("ZegoUIKitPrebuilt instance not created");
      }
    } else {
      console.error("Container ref is not available");
    }

    return () => {
      if (zpRef.current && typeof zpRef.current.leaveRoom === "function") {
        zpRef.current.leaveRoom().catch((error) => {
          console.error("Error leaving the room:", error);
        });
      }
    };
  }, []);

  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        localStreamRef.current = stream; // Store the stream in the ref
        // Additional handling might be required here depending on the SDK's needs
      })
      .catch((error) => console.error("Error accessing media devices:", error));

    return () => {
      if (localStreamRef.current) {
        localStreamRef.current.getTracks().forEach((track) => track.stop()); // Stop all tracks on cleanup
      }
    };
  }, []);

  return (
    <div
      className="myCallContainer"
      ref={refContainer}
      style={{ width: "80vw", height: "90vh" }}
    ></div>
  );
}

export default VideoMeeting;
